import { sendMQTTMessage, parseMqttResult } from '../helper'
import { parseTime } from '@remote/utils'
import fallback from '@shared/assets/img/cinema-fallback.png'
import { IMQTTRes } from '../type'

export function addScrapeDirs () {
  return sendMQTTMessage('xl_shell', 'add_scrape_dirs', {
  })
    .then(parseMqttResult)
}
  
export function addScrapePath (paths: string[], traceId = '') {
  return sendMQTTMessage('xl_shell', 'set_scrape_dirs', { paths, traceId }).then(parseMqttResult)
}
  
export function deleteScrapePath (paths: string[], traceId = '') {
  return sendMQTTMessage('xl_shell', 'del_scrape_dirs', { paths, traceId }).then(parseMqttResult)
}
  
export function updateScrapeAll (isScrapeAll: boolean, traceId = '') {
  const is_all_scrape = isScrapeAll ? 1 : 0
  return sendMQTTMessage('xl_shell', 'set_all_scrape_dirs', { is_all_scrape, traceId }).then(parseMqttResult)
}

export type TSearchScrapeParams = {
  phase: string
  class: '' | 'tv' | 'movie' | 'other'
  page?: number
  last_page_token?: string
  page_size: number
}

export interface IScrapeinfo {
  'name': string
  'trans_name': string
  'other_name': string
  'class': string
  'origin_place': string
  'brief': string
  'year': string
  'actors': { name: string }[]
  'directors': { name: string }[]
  'post_url': [string, string]
  'season': string
  'episode': string
  'title': string
  'xmdb_id': string
}

export type TSearchScrapeItem = {
  file_path: string
  file_name: string
  file_size: string
  file_ut: string
  md5sum: string
  hash: string
  scrape_info: IScrapeinfo
}

export type TSearchScrapeRes = {
  file_nums: number
  last_page_token: string
  result: TSearchScrapeItem[]
}

export async function searchScrape (params: TSearchScrapeParams): Promise<[TSearchScrapeRes, string]> {
  return sendMQTTMessage<IMQTTRes<TSearchScrapeRes>>('xl_shell', 'scrape_search', params).then(data => {
    const { result } = parseMqttResult<TSearchScrapeRes>(data)
    console.log('searchScrape', params, result)
    return [result, params.phase]
  })
}

type TGetOtherScrapesParams = {
  last_page_token: string
  page_size: number
}

export interface IOtherScrapesItem {
  ext: string
  hash: string
  icon_url: string
  md5sum: string
  name: string
  path: string
  size: string
  total: string
  type: string
  ut: string
}

type IGetOtherScrapesRes = {
  file_nums: number
  last_page_token: string
  result: IOtherScrapesItem[]
}

const defaultRuntime = {
  'state': 'finished',
  'stage': 'scraping',
  'dir_total_count': 26,
  'video_total_count': 136,
  'dir_done_count': 742,
  'video_done_count': 742,
  'start_time': '2022/12/05 14:23:08',
  'end_time': '2022/12/05 14:23:19',
  'err_details': null,
}

export async function getOtherScrapes (params: TGetOtherScrapesParams): Promise<API_NFO.GetNFOListResponse> {
  return sendMQTTMessage<IMQTTRes<IGetOtherScrapesRes>>('xl_shell', 'get_other_scrapes', params).then(data => {
    const { result } = parseMqttResult<IGetOtherScrapesRes>(data)
    console.log('getoOtherScrapes', params, result)
    return {
      page_token: result.last_page_token,
      nfos: result.result.map(item => ({
        ...item,
        video_info: {
          file_id: item.md5sum,
          file_name: item.name,
          real_path: item.path,
          file_size: item.size,
        } as unknown,
        scrape_result:{
          class: 'other',
          id: item.md5sum,
          name: item.name,
          poster_vertical: fallback || item.icon_url,
          year: parseTime(item.ut),
        } as  unknown,
      })),
      runtime: defaultRuntime,
    } as API_NFO.GetNFOListResponse
  })
}